// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
// Gets today's date
const today = new Date();

const options = {
    month: "short",
    year: "numeric",
};
// Sets the property of the text element to be a string representing today's date in the user's local format

var UpDate = today.toLocaleDateString("en-US", options);
$w("#text8").text = UpDate.toUpperCase();

});